var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add To Topic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Topics-Add-/-Black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "tags-add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,19.188 C8.41425022,19.7735729 7.46474978,19.7735729 6.879,19.188 L1.5,13.81 C1.21848749,13.5286678 1.06032023,13.1469913 1.06032023,12.7489998 C1.06032023,12.3510087 1.21848749,11.9693322 1.5,11.688 L12,1.188 C12.2814435,0.906736763 12.6631063,0.748999846 13.061,0.748999846 L18.439,0.748999846 C19.2674271,0.748999846 19.939,1.42057288 19.939,2.24899985 L19.939,7.628 C19.939,8.02554721 19.7810182,8.40680161 19.5,8.688",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.189,4.124 C15.9818932,4.124 15.814,4.29189322 15.814,4.499 C15.814,4.70610678 15.9818932,4.874 16.189,4.874 C16.3961068,4.874 16.564,4.70610678 16.564,4.499 C16.564,4.29189322 16.3961068,4.124 16.189,4.124",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.939,
    cy: 17.249,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.939,
    y1: 14.999,
    x2: 16.939,
    y2: 19.499,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.689,
    y1: 17.249,
    x2: 19.189,
    y2: 17.249,
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopics);
export default __webpack_public_path__ + "static/media/topics.7ab7278f16ed8e25b9142685dfa8a347.svg";
export { ForwardRef as ReactComponent };